module.exports = __webpack_public_path__ + "img/KH- Iinvite1.5871e315.png";